import { useState } from 'react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { ClockIcon } from '@heroicons/react/24/outline'

export default function LabStepCheckbox({ step, onToggle, disabled = false }) {
  const [loading, setLoading] = useState(false)

  const handleToggle = async () => {
    if (loading || disabled) return
    
    setLoading(true)
    try {
      await onToggle(step.id)
    } catch (error) {
      console.error('Failed to toggle step:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className={`group flex items-start p-4 rounded-lg border-2 transition-all duration-300 cursor-pointer ${
        step.is_completed
          ? 'bg-green-50 border-green-300 hover:border-green-400'
          : 'bg-white border-gray-200 hover:border-blue-300 hover:shadow-md'
      } ${loading ? 'opacity-60 pointer-events-none' : ''}`}
      onClick={handleToggle}
    >
      {/* Checkbox */}
      <div className="flex-shrink-0 mt-0.5">
        <div
          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
            step.is_completed
              ? 'bg-green-500 border-green-500'
              : 'border-gray-300 group-hover:border-blue-400'
          }`}
        >
          {step.is_completed && (
            <CheckCircleIcon className="w-5 h-5 text-white" />
          )}
        </div>
      </div>

      {/* Content */}
      <div className="ml-4 flex-1">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h4
              className={`font-semibold transition-colors ${
                step.is_completed
                  ? 'text-green-900 line-through'
                  : 'text-gray-900 group-hover:text-blue-600'
              }`}
            >
              <span className="text-sm font-bold text-gray-500 mr-2">
                Step {step.step_number}:
              </span>
              {step.title}
            </h4>
            {step.content && (
              <p
                className={`mt-1 text-sm ${
                  step.is_completed ? 'text-green-700' : 'text-gray-600'
                }`}
              >
                {step.content}
              </p>
            )}
          </div>
          
          {/* Estimated time */}
          <div className="ml-4 flex-shrink-0">
            <div className="flex items-center text-xs text-gray-500">
              <ClockIcon className="w-4 h-4 mr-1" />
              {step.estimated_minutes} min
            </div>
          </div>
        </div>

        {/* Completed timestamp */}
        {step.is_completed && step.completed_at && (
          <div className="mt-2 text-xs text-green-600">
            ✓ Completed {new Date(step.completed_at).toLocaleDateString()}
          </div>
        )}
      </div>
    </div>
  )
}
